(ns quuppa.qsm.site.events
  (:require [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.projects.events :as project-e]
            [quuppa.qsm.ui-state.events :as ui-state]))

(def project-sites-query (q/create-query :qsm/list-sites [:project-id]))

(rf/reg-event-fx :site/get-project-sites
  (fn [_ [_ project-id]]
    {:fx [[::q/execute [project-sites-query {:project-id project-id}]]]}))

(rf/reg-event-fx ::get-qpe-data
  (fn [_ [_ site-id]]
    {:fx [[:dispatch [:init/state-all {:site-id site-id}]]]}))

(rf/reg-event-db :qsm/site-add
  (q/update-event-fn project-sites-query conj))

(rf/reg-event-db :qsm/site-update
  (q/update-event-fn project-sites-query (fn [result site]
                                           ;; Replace matching site in a vector
                                           (into (empty result)
                                                 (map (fn [v]
                                                        (if (= (:id v) (:id site))
                                                          site
                                                          v))
                                                      result)))))

(rf/reg-event-db :qsm/site-remove
  (q/update-event-fn project-sites-query (fn [result {:keys [id]}]
                                           ;; Remove matching site from the vector
                                           (into (empty result) (remove #(= id (:id %)) result)))))
;;
;; New site
;;

(rf/reg-event-fx ::init-new-site-form
  (fn [{:keys [db]} [_ page-key project-id]]
    {:db (-> db
             (assoc :site-form {:data {:name       ""
                                       :project-id project-id}})
             ;; Ensure both forms aren't open
             (dissoc :project-form))
     :fx [[:dispatch [::ui-state/set-sidebar-type page-key :new-site-form]]]}))

(rf/reg-event-fx ::save-new-site
  (fn [{:keys [db]} _]
    {:fx [[:server-dispatch {:event [:qsm/create-site (-> db :site-form :data)]
                             :on-success [::save-site-success]
                             :on-error [::save-site-error "Create site failed"]}]]}))

;;
;; Edit site
;;

(rf/reg-event-db ::init-edit-site-form
  (fn [db [_ site]]
    (assoc db :site-form {:id         (:id site)
                          :original-project-id (:project-id site)
                          ;; :data should only contains properties that are sent to the backend
                          ;; TODO: Location field is deprecated, not editable. For some reason
                          ;; it is still included in list data.
                          :data (select-keys site [:name :project-id :resource-role])})))

(rf/reg-event-fx ::save-site
  (fn [{:keys [db]} _]
    (let [get-data          (fn [& path-keys] (get-in db (apply conj [:site-form :data] path-keys)))
          source-project-id (get-in db [:site-form :original-project-id])
          target-project-id (get-data :project-id)
          projects          (:result (q/get-result db project-e/projects-query {}))
          target-project    (first (filter #(= target-project-id (:id %)) projects))]
      (if (not= source-project-id target-project-id)
        {:fx [[:dispatch [:confirm/open {:title        "Move site?"
                                         :message      [:span [:strong (get-data :name)]
                                                        " site will be moved to "
                                                        [:strong (:name target-project)]
                                                        " project."]
                                         :ok-label     "Move"
                                         :ok-class     "btn btn-danger"
                                         :cancel-class "btn btn-outline-secondary"
                                         :on-confirm   [::save-site-confirmed]}]]]}
        {:fx [[:dispatch [::save-site-confirmed]]]}))))

(rf/reg-event-fx ::save-site-confirmed
  (fn [{:keys [db]} _]
    {:fx [[:server-dispatch {:event [:qsm/save-site (assoc (-> db :site-form :data)
                                                           :site-id (-> db :site-form :id))]
                             :on-success [::save-site-success]
                             :on-error [::save-site-error "Save site failed"]}]]}))

;;
;; New and update site
;;

(rf/reg-event-db ::site-form-set-value
  (fn [db [_ k v]]
    (assoc-in db [:site-form :data k] v)))


(rf/reg-event-db ::cancel-site-form
  (fn [db _]
    (dissoc db :site-form)))

(rf/reg-event-fx ::save-site-success
  (fn [{:keys [db]} _]
    {:db (dissoc db :site-form)
     :fx [[:dispatch [:confirm/close]]]}))

(rf/reg-event-fx ::save-site-error
  (fn [{:keys [db]} [_ message error]]
    {:db (assoc-in db [:site-form :error] {:message message
                                           :data error})}))

(rf/reg-event-fx ::set-qpe-site
  (fn [_ [_ qpe-identity site-id]]
    {:fx [[:server-dispatch {:event [:qsm/set-qpe-site {:identity qpe-identity
                                                        :site-id site-id}]
                             :on-success [:confirm/close]}]]}))

(rf/reg-event-fx ::disconnect-engine
  (fn [_ [_ qpe-identity]]
    {:fx [[:dispatch [:confirm/open {:title "Disconnect the engine from site?"
                                     :message [:span
                                               "The engine will be disconnected from the site."]
                                     :ok-label "Disconnect"
                                     :ok-class "btn btn-danger"
                                     :cancel-class "btn btn-outline-secondary"
                                     :on-confirm [::set-qpe-site qpe-identity nil]}]]]}))

;;
;; Delete site
;;

(rf/reg-event-fx ::delete-site
  (fn [_ [_ site-id site-name]]
    {:fx [[:dispatch [:confirm/open {:title "Delete site?"
                                     :message [:span "You are about to delete "
                                               [:strong site-name]
                                               " site. Are you sure?"]
                                     :ok-label "Delete"
                                     :ok-class "btn btn-danger"
                                     :cancel-class "btn btn-outline-secondary"
                                     :on-confirm [::delete-site-confirmed site-id]}]]]}))

(rf/reg-event-fx ::delete-site-confirmed
  (fn [_ [_ site-id]]
    {:fx [[:server-dispatch {:event [:qsm/delete-site {:site-id site-id}]
                             :on-success [::delete-site-done site-id]
                             :on-error #(js/console.error %)}]]}))

(rf/reg-event-fx ::delete-site-done
  (fn [{:keys [db]} [_ deleted-site-id _result]]
    ;; If we are on deleted site page, redirect to project view list.
    (let [{:keys [site-id project-id]} (-> db :quuppa.routing/match :parameters :path)]
      {:fx [[:dispatch [:confirm/close]]
            (when (and (= :site (-> db :quuppa.routing/match :data :name))
                       (= (str deleted-site-id) site-id))
              [:push-state [:project {:project-id project-id}]])]})))
